export const fields = {
  EVENT_TIME: "eventTime",
  EVENT_CODE: "eventCode",
  IP_ADDRESS: "initiatorIp",
  MESSAGE: "message",
  OBJECT_TYPE: "objectType",
  OBJECT_ID: "objectId",
  SOURCE: "source",
};
